import Tool, {
  type IToolActionInput,
  type IToolEnabledInput,
  simpleToolButton,
} from './Tool';
import Shortcut from '../utils/Shortcut';
import {
  hasIntegrationRecordReference,
  hasRecordReference,
} from '../objects/guards';
import { openIntegrationRecordHandler } from '../shapes/ShapeIntegrationRecord';
import type { ModelName } from '../shared-types';

class ToolOpenRecord extends Tool {
  static toolName = 'Open record';
  static shortcut = new Shortcut('Cmd+O');

  static available({ selection, controller }: IToolEnabledInput): boolean {
    return !!(
      selection &&
      (hasIntegrationRecordReference(selection) ||
        (hasRecordReference(selection) && controller.allowRecordLinking()))
    );
  }

  static action({ controller, selection }: IToolActionInput) {
    if (hasIntegrationRecordReference(selection)) {
      openIntegrationRecordHandler(selection)?.();
    } else if (
      hasRecordReference(selection) &&
      controller.allowRecordLinking()
    ) {
      let { recordRef } = selection.shape;
      const record = selection.shape.recordInfo;

      if (
        record &&
        record.typename === 'Annotation' &&
        record.annotatable.typename === 'Note' &&
        (record.annotatable.notable.typename === 'DiscoveryInterview' ||
          record.annotatable.notable.typename === 'DiscoveryFile')
      ) {
        recordRef = {
          typename: record.annotatable.notable.typename as ModelName,
          id: record.annotatable.notable.id,
        };
      }

      if (recordRef) {
        controller.openRecordInDrawer(recordRef);
      }
    }
  }

  static enabled(args: IToolEnabledInput) {
    return ToolOpenRecord.available(args);
  }

  static buttonComponent() {
    return simpleToolButton(ToolOpenRecord, 'fa-regular fa-sidebar-flip', {
      stopPropagation: true,
    });
  }
}

export default ToolOpenRecord;
